package com.karawek.core.platform

import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toInstant
import kotlinx.datetime.toLocalDateTime
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

@OptIn(ExperimentalTime::class)
interface SecureStorage {
    fun set(key: String, stringValue: String): Boolean
    fun set(key: String, intValue: Int): Boolean
    fun set(key: String, longValue: Long): Boolean
    fun set(key: String, floatValue: Float): Boolean
    fun set(key: String, doubleValue: Double): Boolean
    fun set(key: String, boolValue: Boolean): Boolean
    fun set(key: String, dataValue: ByteArray): Boolean

    fun string(forKey: String): String?
    fun int(forKey: String): Int?
    fun long(forKey: String): Long?
    fun float(forKey: String): Float?
    fun double(forKey: String): Double?
    fun bool(forKey: String): Boolean?
    fun data(forKey: String): ByteArray?

    fun deleteObject(forKey: String): Boolean
    fun clear(): Boolean

    // helpers
    fun set(key: String, instantValue: Instant) = set(key, instantValue.epochSeconds)
    fun set(key: String, value: LocalDateTime) = set(key, value.toInstant(TimeZone.UTC))

    fun instant(forKey: String): Instant? = long(forKey)?.let(Instant::fromEpochSeconds)
    fun localDateTime(forKey: String): LocalDateTime? = instant(forKey)?.toLocalDateTime(TimeZone.UTC)
}

// Platform factory: each target returns a SecureStorage implementation
internal expect fun createSecureStorage(context: PlatformContext, name: String = "default_vault"): SecureStorage
